import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Input from '@mui/material/Input';
import { useEffect, useMemo, useState } from 'react';

import { MemberSignUpForm, ProgressButton } from 'components';
import { useEditMemberSignUpFormMutation, useGetMemberSignUpFormQuery } from 'store/api/version-api.slice';

import { styles } from './styles';

const EditSignUpFormDialog = ({ formOpen, toggleMemberForm, setFormOpen }) => {
	const [formOptions, setFormOptions] = useState([]);
	const [successUrl, setChangeSuccessUrl] = useState('');
	const [memberInfoUrl, setChangeMemberInfoUrl] = useState('');

	const { data: memberSignUpFormResponse = {} } = useGetMemberSignUpFormQuery();

	const memberSignUpForm = useMemo(() => memberSignUpFormResponse.results || [], [memberSignUpFormResponse.results]);

	const [editMemberSignUpForm, { isLoading: isEditLoading }] = useEditMemberSignUpFormMutation();

	const handleChange = options => setFormOptions(options);

	const handleChangeSuccessUrl = e => {
		setChangeSuccessUrl(e.target.value);
	};

	const handleChangeMemberInfoUrl = e => {
		setChangeMemberInfoUrl(e.target.value);
	};

	const handleSave = async () => {
		// Payload is an array of field values: ["emailAddress", "firstName"...]
		const payload = formOptions.reduce((acc, next) => {
			// Dirty solution. It's better to refactor it in the future
			// Pay attention that this component is used in onboarding flow
			if (typeof next === 'string') {
				acc.push(next);
				return acc;
			}

			if (next.checked) {
				acc.push(next.postValue);
				return acc;
			}

			return acc;
		}, []);

		try {
			await editMemberSignUpForm({ id: memberSignUpForm[0].id, payload, successUrl, memberInfoUrl });
		} finally {
			setFormOpen(false);
		}
	};

	useEffect(() => {
		if (memberSignUpForm.length > 0) {
			setFormOptions(memberSignUpForm[0].form_options);
			setChangeSuccessUrl(memberSignUpForm[0].success_url || '');
			setChangeMemberInfoUrl(memberSignUpForm[0].member_info_url || '');
		}
	}, [memberSignUpForm]);

	return (
		<Dialog
			maxWidth={'md'}
			fullWidth={true}
			open={formOpen}
			onClose={toggleMemberForm}
			aria-labelledby="alert-dialog-title"
			aria-describedby="alert-dialog-description"
		>
			<DialogTitle id="alert-dialog-title">Edit Sign Up Form</DialogTitle>
			<DialogContent>
				<DialogContentText id="alert-dialog-description">
					<MemberSignUpForm options={formOptions} handleChange={handleChange} />
					<Box sx={styles.successWrapper}>
						<Box sx={styles.successContent}>
							<span>Success URL:</span>
							<Input
								type="text"
								value={successUrl}
								onChange={handleChangeSuccessUrl}
								defaultValue="https://"
							/>
						</Box>
						<p>This is the webpage members will be sent to on successful form submission.</p>
					</Box>
					<Box sx={styles.successWrapper}>
						<Box sx={styles.successContent}>
							<span>Membership Information URL:</span>
							<Input
								type="text"
								value={memberInfoUrl}
								onChange={handleChangeMemberInfoUrl}
								defaultValue="https://"
							/>
						</Box>
						<p>
							This is the webpage potenial members will be sent to learn more about membership benefits.
							Currently only implemented for Gated Content.
						</p>
					</Box>
				</DialogContentText>
			</DialogContent>
			<DialogActions>
				<Button variant="contained" color="inherit" onClick={toggleMemberForm}>
					Cancel
				</Button>
				<ProgressButton
					circleColor="secondary"
					button={
						<Button onClick={handleSave} variant="contained" color="primary" autoFocus>
							Save
						</Button>
					}
					isLoading={isEditLoading}
				/>
			</DialogActions>
		</Dialog>
	);
};

export default EditSignUpFormDialog;
